import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterUser_template } from "./filterUser_template";
import { imageWidget_template } from "./imageWidget_template";
import { filterTag_template } from "./filterTag_template";
import { DragAndDropHandler } from "../../utils/DragAndDropHandler";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;
declare var Dropzone: any;

export class videosEdit_template extends vnTemplate {
    protected filterUser_producer: filterUser_template;
    protected pagination: pagination_template;
    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;
    public imageWidgetForVideoThumbnail: imageWidget_template;
    public filterTag: filterTag_template;
    public filterCategory: multipleSelector_template;
    protected subtitlesTypesToolTip: infoButton_template;
    protected subtitlesAutoGenToolTip: infoButton_template;
    protected subtitlesTypesTooltipContent;
    protected subtitlesAutoGenTooltipContent;

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="form-header video-edit">
                <input id="user-id" data-bind="value: id" type="hidden">
                <!-- ko ifnot: $data.id() -->
                <h3 class="form-title icon i-video-2">Create Video</h3>
                <!-- /ko -->
                <!-- ko if: $data.id() -->
                <h3 class="form-title icon i-video-2">Edit Video</h3>
                <!-- /ko -->
                <button data-bind="event: { click: onClickCancel }, css: { 'is-disable' : isSaveButtonDisabled() }, disable: isSaveButtonDisabled()" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': true }">

                <div class="w-form-body video">
                    <div class="form-body">

                        <strong class="form-sub-title">Upload</strong>

                        <div class="form-group inside-label">
                            <label for="url" class="form-label">Video</label>
                            <div id="dropzone">
                                <div id="my-drop-zone" class="dropzone"></div>
                            </div>
                            <input id="url" data-bind="value: url" type="hidden">
                        </div>

                        <div class="form-group">
                            <dl class="double-list">
                                <dt style="grid-column: 1 / span 2"><span>URL</span></dt><dd class="flex" style="grid-column: 1 / span 2;text-align: left;border-bottom: 0px solid black"><span class="no-cap" data-bind="text: url"></span><a style="margin-left: 1rem;" class="btn icon border only-icon i-view" target="_blank" rel="noopener noreferrer" data-bind="visible: showVideoUrlButton, attr: { href: url }"></a></dd>
                                <dt><span>Duration</span></dt><dd><span data-bind="text: length"></span></dd>
                                <dt><span>Size</span></dt><dd><span data-bind="text: sizeHuman"></span></dd>
                                <dt><span>Dimension</span></dt><dd><span data-bind="text: width"></span><span class="no-cap">px&nbsp;x&nbsp;</span><span data-bind="text: height"></span><span class="no-cap">px</span></dd>
                                <dt><span>Ratio</span></dt><dd><span data-bind="text: ratio"></span></dd>
                                <dt><span>MIME Type</span></dt><dd><span class="no-cap" data-bind="text: mimeType"></span></dd>
                                <dt><span>Date Uploaded</span></dt><dd><span data-bind="text: dateCreated"></span></dd>
                                <dt><span>Date Updated</span></dt><dd><span data-bind="text: dateUpdated"></span></dd>
                            </dl>
                        </div>

                        <div class="form-group img">
                            <label for="thumbnail" class="form-label">Thumbnail</label>
                            ${this.imageWidgetForVideoThumbnail.getHtmlBuild()}
                        </div>

                    </div>

                    <div class="form-body">

                        <strong class="form-sub-title">Video Information</strong>

                        <div class="form-group inside-label">
                            <label for="title" class="form-label">Title</label>
                            <input id="title" data-bind="value: title" type="text" class="input-text">
                        </div>
                        <div class="form-group inside-label">
                            <label for="description" class="form-label">Description</label>
                            <textarea  id="description" name="description" data-bind="value: description"></textarea>
                        </div>
                        <div class="form-group">
                            <div class="form-check-inline" data-bind="if: hasAccessIsUnderEmbargo() && permissions()['article_edit_embargo'].write">
                                <input type="checkbox" data-bind="checked: isUnderEmbargo" id="isUnderEmbargo">
                                <label for="isUnderEmbargo" class="form-label icon i-check">Under Embargo</label>
                            </div>
                        </div>
                        <div class="form-group inside-label">
                            <label for="producer" class="form-label">Producer</label>
                            ${this.filterUser_producer.getHtmlBuild()}
                        </div>

                        <strong class="form-sub-title">Video Article</strong>
                        <div class="form-group">
                            <!-- ko if: $data.id() -->
                            <button class="btn secondary icon i-video" type="button" data-bind=" event: { click: onClickGenerateVideoArticle }, text: videoArticleId() ? 'View Video Article' : 'Generate Video Article'"></button>
                            <!-- /ko -->
                        </div>

                        <strong class="form-sub-title">Categorization</strong>

                        <div class="form-group">
                            <label for="idContentType" class="form-label form-label-box">Content Type</label>
                            <select id="idContentType" data-bind="options: contentTypes, optionsText: 'name', value: idContentType, optionsValue: 'id'"></select>
                        </div>

                        <div class="form-group">
                            <hr class="form-hr" />
                        </div>


                        <div class="form-group">
                            ${this.filterCategory.getHtmlBuild()}
                            <div style="display: none;" id="filters-selected" class="filters-selected"></div>
                        </div>

                        <div class="form-group w-radio" data-bind="foreach: selectedCategories, childrenComplete : handleDragAndDrop($element, selectedCategories ,'.category-element', { dragHandleSelector: '.drag-handle' })">
                            <div class="btn-selection category-element">
                                <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                <input type="radio" name="category" data-bind="attr: { value: $data.category.id, id: 'category_' + $data.category.id, checked: $parent.idPrimaryCategory() == $data.category.id ? $parent.idPrimaryCategory() : null }, event: { click: $parent.onClickSetSelectedPrimaryCategory }">
                                <label class="form-label" data-bind="text: $data.category.name, attr: { for: 'category_' + $data.category.id }"></label>
                                <button class="icon i-x-after" type="button" data-bind="visible: true, event: { click: $parent.onClickDeleteSelectedCategory }"></button>
                            </div>
                        </div>
                        <div class="form-group">
                            <hr class="form-hr" />
                        </div>
                        <div class="form-group inside-label" style="align-items: flex-start;">
                            <label class="form-label" style="width: auto;">Tags</label>
                            ${this.filterTag.getHtmlBuild()}
                        </div>
                        <div class="form-group" data-bind="foreach: selectedTags, childrenComplete : handleDragAndDrop($element, selectedTags ,'.tag-element', { dragHandleSelector: '.drag-handle' })">
                            <div class="btn-selection tag-element">
                                <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                <input type="radio" name="tag" data-bind="attr: { value: $data.tag.id, id: 'tag_' + $data.tag.id, checked: $parent.idPrimaryTag() == $data.tag.id ? $parent.idPrimaryTag() : null }, event: { click: $parent.onClickSetSelectedPrimaryTag }">
                                <label class="form-label" data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset, attr: { for: 'tag_' + $data.tag.id }"></label>
                                <button class="icon i-x-after" type="button" data-bind="visible: true, event: { click: $parent.onClickDeleteSelectedTag }"></button>
                            </div>
                        </div>

                        <strong class="form-sub-title">Subtitles</strong>


                        <div class="form-group row" style="justify-content: flex-start">
                            <div id="dropzone-2">
                                <div id="my-drop-zone-2" class="dropzone" style="display: grid;">
                                     <button class="btn secondary icon i-upload" type="button" style="pointer-events: none">Upload Subtitles</button>
                                </div>
                            </div>
                            <button class="btn secondary icon i-settings" type="button" data-bind="event: { click: onClickAutoGenerateSubtitles }, css: { 'is-disable' : isSaveButtonDisabled() }, disable: isSaveButtonDisabled()">Automatically Generate Subtitles</button>
                            <div class="w-tooltips-adv pos-far-left short">${this.subtitlesAutoGenToolTip.getHtmlBuild()}</div>
                        </div>

                        <!-- ko if: subtitlesFiles().length -->
                        <table class="list-action subtitles">
                            <thead>
                                <tr>
                                    <th><span>URL</span></th>
                                    <th><span>Language</span></th>
                                    <th><span style="display: flex; flex-direction: row;justify-content: center;align-items: center; margin-left: 10px">Type <div class="w-tooltips-adv pos-far-left short">${this.subtitlesTypesToolTip.getHtmlBuild()}</div></span></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody  data-bind="foreach: subtitlesFiles">
                                <tr>
                                    <td>
                                        <span data-bind="text: $data.urlHuman" style="text-transform: none;"></span>
                                        <input id="subtitlesUrls[]" data-bind="value: $data.url" type="hidden">
                                        <input id="subtitlesSizes[]" data-bind="value: $data.sizeHuman" type="hidden">
                                        <input id="subtitlesMimeTypes[]" data-bind="value: $data.mimeType" type="hidden">
                                    </td>
                                    <td>
                                        <select id="subtitlesLanguages[]" data-bind="options: $parent.subtitlesLanguages, optionsText: 'name', value: $data.idLanguage, optionsValue: 'id', optionsAfterRender: $parent.setOptionDisable"></select>
                                    </td>
                                    <td>
                                        <select id="subtitlesTypes[]" data-bind="options: $parent.subtitlesTypes, optionsText: 'name', value: $data.type, optionsValue: 'id', optionsAfterRender: $parent.setOptionDisable"></select>
                                    </td>
                                    <td>
                                        <div style="display: flex;">
                                            <button class="btn border only-icon icon border highlight i-download" type="button" data-bind="click: $parent.onClickDownloadSubtitle, hidden: $data.url == 'auto-generated'">
                                                <span class="hidden-text">Download</span>
                                            </button>
                                            <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="click: $parent.onClickDeleteSubtitle">
                                                <span class="hidden-text">Delete</span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- /ko -->
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }, css: { 'is-disable' : isSaveButtonDisabled() }, disable: isSaveButtonDisabled()" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }, css: { 'is-disable' : isSaveButtonDisabled() }, disable: isSaveButtonDisabled(), text: isSaveButtonDisabled() ? 'Saving...' : 'Save Video'" class="btn highlight" type="button">Save Video</button>
            </div>

            ${this.imagePicker.getHtmlBuild()}
        `;
    }

    protected initPartial(): void {
        this.filterUser_producer = new filterUser_template(
            "filterUser_producer",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.filterUser_producer.setUniqueIdentifier("producerId");
        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller,
        );
        this.imageWidgetForVideoThumbnail = new imageWidget_template("menu_image", this.getTemplateViewModel(), this);
        this.imageWidgetForVideoThumbnail.setMode("single-select");
        this.imageWidgetForVideoThumbnail.setCaller(this.imagePickerHelper);

        this.filterTag = new filterTag_template("filterTag", this.getTemplateViewModel(), this.caller);

        this.filterCategory = new multipleSelector_template(
            "article_categoryFilter",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.filterCategory.setFilterContainerClass("margin-neg");
        this.filterCategory.setSelectAllEnabled(false);
        this.filterCategory.setSearchEnabled(false);
        this.filterCategory.setLabel("Categories");

        this.subtitlesTypesTooltipContent = `
            <ul>
                <li>Non-SDH: Meant for hearing audiences. The only transcribed element of non-SDH subtitles is dialogue.</li>
                <li>SDH: Optimized for the deaf and hard of hearing. These subtitles assume the end user cannot hear the dialogue and include important non-dialogue information such as sound effects, music, and speaker identification.</li>
                <li>Forced Narrative: Clarifies communications or alternate languages meant to be understood by the viewer. Inclusion is forced unless another subtitle file is activated.</li>
            </ul>`
        this.subtitlesTypesToolTip = new infoButton_template('subtitlesTypesToolTip', this.getTemplateViewModel(), this.caller)
        this.subtitlesTypesToolTip.setTitle('Subtitle Type');
        this.subtitlesTypesToolTip.setContent(this.subtitlesTypesTooltipContent);

        this.subtitlesAutoGenTooltipContent = `<p>Subtitle files will be queued for automatic generation by an external service as configured on save of the video. Once generated, the subtitle files will become available on the website without the need for user intervention.</p>`;
        this.subtitlesAutoGenToolTip = new infoButton_template('subtitlesAutoGenToolTip', this.getTemplateViewModel(), this.caller)
        this.subtitlesAutoGenToolTip.setTitle('Automatically Generated Subtitles');
        this.subtitlesAutoGenToolTip.setContent(this.subtitlesAutoGenTooltipContent);
    }

    protected getTemplateName(): string {
        return "videosEdit-form-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            id: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            isSaveButtonDisabled: ko.observable(false),
            description: ko.observable(""),
            details: ko.observable(""),
            height: ko.observable(""),
            length: ko.observable(""),
            mimeType: ko.observable(""),
            producer: ko.observable({}),
            idProducer: ko.observable(null),
            ratio: ko.observable(""),
            size: ko.observable(""),
            sizeHuman: ko.observable(""),
            thumbnail: ko.observable(""),
            title: ko.observable(""),
            url: ko.observable(""),
            width: ko.observable(""),
            isEditShown: ko.observable(false),
            isUnderEmbargo: ko.observable(false),
            hasAccessIsUnderEmbargo: ko.observable(false),
            lockItem: ko.observable(true),
            permissions: ko.observableArray(this.initPermissions(["article_edit_embargo"])),
            showVideoUrlButton: ko.observable(false),
            selectedTags: ko.observableArray([]),
            idPrimaryTag: ko.observable(null),
            categories: ko.observableArray([]),
            selectedCategories: ko.observableArray([]),
            idPrimaryCategory: ko.observable(null),
            contentTypes: ko.observableArray([]),
            idContentType: ko.observable(""),
            subtitlesFiles: ko.observableArray([]),
            subtitlesLanguages: ko.observableArray([]),
            videoArticleId: ko.observable(false),
            idBunnyVideo: ko.observable(null),
            idBunnyVideoPreview: ko.observable(null),
            // subtitlesTypes: ko.observableArray([
            //     { id: null, name: "Select an Option" },
            //     { id: "Non-SDH", name: "Non-SDH" },
            //     { id: "SDH", name: "SDH" },
            //     { id: "Forced Narrative", name: "Forced Narrative" },
            // ]),
            subtitlesTypes: ko.observableArray([
                //{ id: null,               name: "Select an Option", disable: ko.observable(true)},
                { id: "Non-SDH",          name: "Non-SDH",          disable: ko.observable(false)},
                { id: "SDH",              name: "SDH",              disable: ko.observable(true)},
                { id: "Forced Narrative", name: "Forced Narrative", disable: ko.observable(true)},
            ]),
            setOptionDisable: function(option, item) {
                ko.applyBindingsToNode(option, {disable: item.disable}, item);
            },
            onClickSave: (data) => {
                self.onClickSave();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
            handleDragAndDrop: function (element, currentObservableArray, childrenSelector) {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
            onClickDeleteSelectedTag: function (data, event) {
                self.onClickDeleteSelectedTag(data);
            },
            onClickSetSelectedPrimaryTag: function (data, event) {
                self.setSelectedPrimaryTag(data);
                return true;
            },
            onClickDeleteSelectedCategory: function (data, event) {
                self.onClickDeleteSelectedCategory(data);
            },
            onClickSetSelectedPrimaryCategory: function (data, event) {
                self.setSelectedPrimaryCategory(data);
                return true;
            },
            onClickOpenUploadVideoPopup: function (data, event) {
                self.openUploadVideoPopup();
            },
            onClickCloseUploadVideoPopup: function (data, event) {
                self.closeUploadVideoPopup();
            },
            onClickDeleteSubtitle: function (data) {
                self.deleteSubtitle(data);
            },
            onClickDownloadSubtitle : function (data){
                self.downloadSubtitle(data.url)
            },
            onClickAutoGenerateSubtitles: (data) => {
                if (self.getTemplateViewModel().isSaveButtonDisabled()) {
                    return;
                }
                let subtitlesFiles = self.getTemplateViewModel().subtitlesFiles();
                let subtitlesFile = {
                    id: null,
                    title: "auto-generated",
                    url: "auto-generated",
                    urlHuman: "Queued for automatic generation",
                    size: 0,
                    sizeHuman: this.formatBytes(0),
                    mimeType: "text/vtt",
                    idLanguage: 1,
                    type: "Non-SDH",
                };
                subtitlesFiles.push(subtitlesFile);
                self.getTemplateViewModel().subtitlesFiles(subtitlesFiles);
            },
            onClickGenerateVideoArticle : function (data) {
                self.generateVideoArticle(data);
            }
        };
    }

    protected onClickCancel(): void {
        if (this.getTemplateViewModel().isSaveButtonDisabled()) {
            return;
        }
        this.caller.goBack();
    }

    protected onClickSave(): void {
        if (this.getTemplateViewModel().isSaveButtonDisabled()) {
            return;
        }
        this.disableSaveButtons();
        this.caller.save();
    }

    public disableSaveButtons(): void {
        this.getTemplateViewModel().isSaveButtonDisabled(true);
    }

    public enableSaveButtons(): void {
        this.getTemplateViewModel().isSaveButtonDisabled(false);
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setTitle(title): void {
        this.getTemplateViewModel().title(title);
    }

    public setDescription(description): void {
        this.getTemplateViewModel().description(description);
    }

    public setUrl(url): void {
        this.getTemplateViewModel().url(url);
    }

    public setLength(length): void {
        this.getTemplateViewModel().length(length);
    }

    public setSize(size): void {
        this.getTemplateViewModel().size(size);
    }

    public setSizeHuman(size): void {
        this.getTemplateViewModel().sizeHuman(this.formatBytes(size));
    }

    public setHeight(height): void {
        this.getTemplateViewModel().height(height);
    }

    public setWidth(width): void {
        this.getTemplateViewModel().width(width);
    }

    public setRatio(ratio): void {
        this.getTemplateViewModel().ratio(ratio);
    }

    public setMimeType(mimeType): void {
        this.getTemplateViewModel().mimeType(mimeType);
    }

    public setDateCreated(dateCreated): void {
        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setDateUpdated(dateUpdated): void {
        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public setProducer(producer): void {
        if (producer) {
            this.getTemplateViewModel().filterUser_producer.users(producer);
            this.getTemplateViewModel().filterUser_producer.user(producer.valnet_user.fullNameAndLogin);
            this.getTemplateViewModel().filterUser_producer.idUser(producer.id);
            this.getTemplateViewModel().producer(producer);
            this.filterUser_producer.toggleCloseButton();
        }
        this.filterUser_producer.setUsers(producer);
    }

    public setIdProducer(idProducer): void {
        this.getTemplateViewModel().idProducer(idProducer);
    }

    public setIdPrimaryTag(idPrimaryTag): void {
        this.getTemplateViewModel().idPrimaryTag(idPrimaryTag);
    }

    public setThumbnail(thumbnail): void {
        this.getTemplateViewModel().thumbnail(thumbnail);
    }

    public setDetails(details): void {
        this.getTemplateViewModel().details(details);
    }

    public setIsUnderEmbargo(isUnderEmbargo): void {
        this.getTemplateViewModel().isUnderEmbargo(isUnderEmbargo);
    }

    public setHasAccessIsUnderEmbargo(hasAccessIsUnderEmbargo) {
        this.getTemplateViewModel().hasAccessIsUnderEmbargo(hasAccessIsUnderEmbargo);
    }

    public setLockItem(lockItem) {
        this.getTemplateViewModel().lockItem(lockItem);
    }

    public setPermissions(permissions) {
        this.getTemplateViewModel().hasAccessIsUnderEmbargo(permissions.article_list_brand.read);

        this.getTemplateViewModel().permissions(permissions);
    }

    public setIdBunnyVideo(idBunnyVideo): void {
        this.getTemplateViewModel().idBunnyVideo(idBunnyVideo);
    }

    public setIdBunnyVideoPreview(idBunnyVideoPreview): void {
        this.getTemplateViewModel().idBunnyVideoPreview(idBunnyVideoPreview);
    }

    public generateDropzone(video) {
        let clickable = !video.id;
        let myDropzone = new Dropzone("div#my-drop-zone", {
            url: this.caller.getUploadUrl(),
            maxFiles: 1,
            acceptedFiles: "video/mp4",
            clickable: clickable,
            maxFilesize: 1024 * 1024 * 40000, // 41,943,040,000
        });
        let _this = this;

        myDropzone.on("success", function (file, fileInfo) {

            if (fileInfo.sizeWarning === true) {
                if (confirm(fileInfo.sizeWarningMessage) === false) {
                    this.removeFile(this.files[0]);
                }
            }
            _this.getTemplateViewModel().height(fileInfo.height);
            _this.getTemplateViewModel().length(fileInfo.length);
            _this.getTemplateViewModel().mimeType(fileInfo.mimeType);
            _this.getTemplateViewModel().ratio(fileInfo.ratio);
            _this.getTemplateViewModel().size(fileInfo.size);
            _this.getTemplateViewModel().sizeHuman(_this.formatBytes(fileInfo.size));
            _this.getTemplateViewModel().title(fileInfo.title);
            _this.getTemplateViewModel().url(fileInfo.url);
            _this.getTemplateViewModel().width(fileInfo.width);
            _this.getTemplateViewModel().showVideoUrlButton(true);
            _this.getTemplateViewModel().idBunnyVideo(fileInfo.idBunnyVideo);
            _this.getTemplateViewModel().idBunnyVideoPreview(fileInfo.idBunnyVideoPreview);
        });
        myDropzone.on("error", function (file, message) {
            //console.log(message.validations[0]);
            const elements = document.querySelectorAll(".dz-error-message span");
            const lastElement = elements[elements.length - 1];
            lastElement.textContent = message.validations[0].messages[0];
        });
        myDropzone.on("addedfile", function (file) {
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            }

            _this.getTemplateViewModel().subtitlesFiles.push({
                id: null,
                title: "auto-generated",
                url: "auto-generated",
                urlHuman: "Queued for automatic generation",
                size: 0,
                sizeHuman: _this.formatBytes(0),
                mimeType: "text/vtt",
                idLanguage: 1,
                type: "Non-SDH",
            });
        });

        if (video && video.url) {
            let mockFile = { name: video.url, size: parseInt(video.size) };
            myDropzone.emit("addedfile", mockFile);
            myDropzone.createThumbnailFromUrl(mockFile, mockFile.name);
            myDropzone.emit("complete", mockFile);
            myDropzone.files.push(mockFile);
            _this.getTemplateViewModel().url(video.url);
            _this.getTemplateViewModel().showVideoUrlButton(true);
        }
    }

    public generateDropzoneSubtitles(video) {
        let _this = this;
        let subtitlesFiles = this.getTemplateViewModel().subtitlesFiles();

        let myDropzone = new Dropzone("div#my-drop-zone-2", {
            url: this.caller.getUploadUrlSubtitles(),
            maxFiles: null,
            acceptedFiles: ".vtt",
            clickable: true,
            maxFilesize: 1024 * 1024 * 1, // 1,048,576
            addRemoveLinks: false,
            dictRemoveFileConfirmation: "Are you sure you want to remove this subtitles file?",
            dictDefaultMessage: "",
            disablePreviews: true,
            previewsContainer: false
        });


        myDropzone.on("success", function (file, fileInfo) {
            let subtitlesFiles = _this.getTemplateViewModel().subtitlesFiles();
            let addFile = true;
            let urlParsed = new URL(fileInfo.url);
            let subtitlesFile = {
                id: null,
                title: fileInfo.title,
                url: fileInfo.url,
                urlHuman: urlParsed.pathname,
                size: parseInt(fileInfo.size),
                sizeHuman: _this.formatBytes(fileInfo.size),
                mimeType: fileInfo.mimeType,
                idLanguage: null,
                type: null,
            };
            subtitlesFiles.forEach((sub) => {
                if (sub.url == subtitlesFile.url) {
                   addFile = false;
                }
            });
            if (addFile) {
                subtitlesFiles.push(subtitlesFile);
            }
            _this.getTemplateViewModel().subtitlesFiles(subtitlesFiles);
        });

        myDropzone.on("removedfile", function (file) {
            let url = file.name;
            if (file && file.xhr && file.xhr.response) {
                let response =  JSON.parse(file.xhr.response);
                url = response.url;
            }
            let subtitlesFiles = _this.getTemplateViewModel().subtitlesFiles();
            let filtered = subtitlesFiles.filter(function(el) { return el.url != url; });
            _this.getTemplateViewModel().subtitlesFiles(filtered);
        });

        myDropzone.on("error", function (file, message) {
            const elements = document.querySelectorAll(".dz-error-message span");
            const lastElement = elements[elements.length - 1];
            lastElement.textContent = message.validations[0].messages[0];
        });

        if (video && video.videoSubtitles && video.videoSubtitles.length > 0) {
            this.getTemplateViewModel().subtitlesFiles([]);
            let subtitlesFiles = [];
            video.videoSubtitles.forEach((fileInfo) => {
                if (fileInfo.id !== null) {
                    let urlHuman = "";
                    if (fileInfo.url == "auto-generated") {
                        urlHuman = "Queued for automatic generation";
                    } else {
                        let urlParsed = new URL(fileInfo.url);
                        urlHuman = urlParsed.pathname;
                    }
                    let subtitlesFile = {
                        id: fileInfo.id,
                        title: fileInfo.title,
                        url: fileInfo.url,
                        urlHuman: urlHuman,
                        size: parseInt(fileInfo.size),
                        sizeHuman: _this.formatBytes(fileInfo.size),
                        mimeType: fileInfo.mimeType,
                        idLanguage: fileInfo.idLanguage,
                        type: fileInfo.type,
                    };
                    subtitlesFiles.push(subtitlesFile);
                    let mockFile = { name: fileInfo.url, size: parseInt(fileInfo.size) };
                    myDropzone.emit("addedfile", mockFile);
                    myDropzone.createThumbnailFromUrl(mockFile, mockFile.name);
                    myDropzone.emit("complete", mockFile);
                    myDropzone.files.push(mockFile);
                }
            });

            this.getTemplateViewModel().subtitlesFiles(subtitlesFiles);
        } else {
            this.getTemplateViewModel().subtitlesFiles([]);
        }
    }

    public formatBytes(bytes, decimals = 2, binaryUnits = 1024) {
        if (bytes == 0) {
            return "0 Bytes";
        }
        var unitMultiple = binaryUnits ? 1024 : 1000;
        var unitNames =
            unitMultiple === 1024 // 1000 bytes in 1 Kilobyte (KB) or 1024 bytes for the binary version (KiB)
                ? ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
                : ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        var unitChanges = Math.floor(Math.log(bytes) / Math.log(unitMultiple));
        return (
            parseFloat((bytes / Math.pow(unitMultiple, unitChanges)).toFixed(decimals || 0)) +
            " " +
            unitNames[unitChanges]
        );
    }

    public setUsers(users) {
        this.getTemplateViewModel().filterUser_producer.users(users);
    }

    public updateSelectedTags() {
        let idTagSelected = this.filterTag.getTemplateViewModel().idTag();
        let tagSelected = this.filterTag.getTemplateViewModel().tagObj();
        let selectedTags = this.getTemplateViewModel().selectedTags();

        if (idTagSelected != null) {
            //add to selected tags if its not already selected
            let alreadySelected = selectedTags.find((t) => t.tag.id == idTagSelected);

            if (!alreadySelected) {
                if (tagSelected.tagType != null) {
                    tagSelected.type = {};
                    tagSelected.type.id = tagSelected.idType;
                    tagSelected.type.name = tagSelected.tagType;
                }
                selectedTags.push({ id: null, tag: tagSelected });
            }
        }

        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.filterTag.clearInput();
    }

    protected setTagFilterAutocomplete(tags) {
        this.filterTag.getTemplateViewModel().tags(tags);
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public setSelectedTags(selectedTags): void {
        selectedTags.forEach((t) => {
            let formattedTagTypeAndDataset = "";
            if (t.tag.type != null) {
                formattedTagTypeAndDataset = " (" + t.tag.type.name + ")";
            }

            if (!t.tag["formattedTagTypeAndDataset"]) {
                t.tag["formattedTagTypeAndDataset"] = formattedTagTypeAndDataset;
            }
        });
        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected onClickDeleteSelectedTag(data) {
        let idPrimaryTag = this.getTemplateViewModel().idPrimaryTag();
        let selectedTags = this.getTemplateViewModel().selectedTags();
        let index = selectedTags.findIndex((i) => i.tag.id == data.tag.id);
        if (index != -1) {
            selectedTags.splice(index, 1);
        }

        if (idPrimaryTag == data.tag.id) {
            this.getTemplateViewModel().idPrimaryTag(null);
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected setSelectedPrimaryTag(data) {
        this.getTemplateViewModel().idPrimaryTag(data.tag.id);
        //console.log(this.getTemplateViewModel().idPrimaryTag());
    }

    public updateSelectedCategories() {
        let selectedFilterCategories = this.filterCategory.getSelectedItems();
        let categories = this.getTemplateViewModel().categories();
        let idPrimaryCategory = this.getTemplateViewModel().idPrimaryCategory();

        let categoryList = [];

        //build list of the categories that are now selected in the filter
        for (let idCategory of selectedFilterCategories) {
            let category = categories.find((c) => c.id == idCategory);
            if (category) {
                categoryList.push(category);
            }
        }

        let selectedCats = this.getTemplateViewModel().selectedCategories();

        //add categories that have not yet been selected
        for (let cat of categoryList) {
            let existingCategory = selectedCats.find((c) => c.category.id == cat.id);

            if (!existingCategory) {
                selectedCats.push({ id: null, category: cat });
            }
        }

        for (let i = selectedCats.length - 1; i >= 0; i--) {
            let catToRemove = categoryList.find((c) => c.id == selectedCats[i].category.id);
            if (!catToRemove) {
                selectedCats.splice(i, 1);
            }
        }

        //check if primary category still exists
        let primaryCategory = selectedCats.find((c) => c.category.id == idPrimaryCategory);
        if (!primaryCategory) {
            this.getTemplateViewModel().idPrimaryCategory(null);
        }

        this.getTemplateViewModel().selectedCategories([]);
        this.getTemplateViewModel().selectedCategories(selectedCats);
    }

    protected onClickDeleteSelectedCategory(data) {
        let idPrimaryCategory = this.getTemplateViewModel().idPrimaryCategory();
        let allCategories = this.getTemplateViewModel().categories();
        let selectedCategories = this.getTemplateViewModel().selectedCategories();
        let index = selectedCategories.findIndex((i) => i.category.id == data.category.id);
        if (index != -1) {
            selectedCategories.splice(index, 1);
        }

        if (idPrimaryCategory == data.category.id) {
            this.getTemplateViewModel().idPrimaryCategory(null);
        }

        this.getTemplateViewModel().selectedCategories(selectedCategories);

        let selectedFilterCategories = this.filterCategory.getSelectedItems();

        index = selectedFilterCategories.findIndex((i) => i == data.category.id);
        if (index != -1) {
            selectedFilterCategories.splice(index, 1);
        }

        let updatedCats = [];
        for (let idCat of selectedFilterCategories) {
            let cat = allCategories.find((c) => c.id == idCat);
            if (cat) {
                updatedCats.push(cat);
            }
        }

        this.filterCategory.setSelectedItems(updatedCats);
    }

    public setSelectedCategories(categories): void {
        let selectedCategories = [];
        selectedCategories = categories.map((e) => e.category);
        this.filterCategory.setSelectedItems(selectedCategories);
        this.getTemplateViewModel().selectedCategories(categories);
    }

    public setIdPrimaryCategory(idPrimaryCategory): void {
        this.getTemplateViewModel().idPrimaryCategory(idPrimaryCategory);
    }

    public setCategories(items) {
        this.getTemplateViewModel().categories(items);
        this.filterCategory.setItems(items);
    }

    public setContentTypes(contentTypes: Array<{}>): void {
        this.getTemplateViewModel().contentTypes(contentTypes);
    }

    protected setSelectedPrimaryCategory(data) {
        this.getTemplateViewModel().idPrimaryCategory(data.category.id);
    }

    public setIdContentType(idContentType): void {
        this.getTemplateViewModel().idContentType(idContentType);
    }

    public setSubtitlesLanguages(subtitlesLanguages): void {
        let subtitlesLanguagesNew = [];
        subtitlesLanguages.forEach((language) => {
            subtitlesLanguagesNew.push({ id: language.id, name: language.name, disable: ko.observable(language.name !== "English") });
        })
        this.getTemplateViewModel().subtitlesLanguages(subtitlesLanguagesNew);
    }

    public setVideoArticleId(videoArticleId : any): void {
        this.getTemplateViewModel().videoArticleId(videoArticleId);
    }

    public openUploadVideoPopup() {
        document.getElementById('upload-video-popup').classList.add('is-visible');
        document.body.classList.add('is-fixed');
    }

    public closeUploadVideoPopup(){
        document.getElementById('upload-video-popup').classList.remove('is-visible');
        document.body.classList.remove('is-fixed');
    }

    protected deleteSubtitle(data) {
        if (confirm("Are you sure you want to remove this subtitles file?") === true) {
            data.name = data.url;
            let subtitlesFiles = this.getTemplateViewModel().subtitlesFiles();
            let filtered = subtitlesFiles.filter(function(el) { return el.url != data.url; });
            this.getTemplateViewModel().subtitlesFiles(filtered);
        }
    }

    protected downloadSubtitle(url){
        this.caller.downloadSubtitle(url)
    }

    protected generateVideoArticle(data) {

        this.caller.generateVideoArticle(data, this.getTemplateViewModel().videoArticleId());
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/videosEdit_template.ts